import React from 'react';
import { motion } from 'framer-motion';
import { Flame, Check, Sparkles } from 'lucide-react';
import { TrustBadges } from './TrustBadges';
const CHECKOUT_URL = 'https://checkout.complementodigital.shop/cart/40758159638657:1';
const features = ['6 Tomos Completos del sistema', '3 Bonus exclusivos incluidos', 'Acceso digital inmediato', 'Compatible con celular y PC'];
interface OfferSelectorProps {
  variant?: 'full' | 'compact';
  showTrust?: boolean;
  ctaLabel?: string;
}
export function OfferSelector({
  variant = 'full',
  showTrust = true,
  ctaLabel = 'COMPRAR AHORA'
}: OfferSelectorProps) {
  const handlePurchase = () => {
    window.location.href = CHECKOUT_URL;
  };
  return <div className="w-full" data-id="element-207">
      <div className="bg-dark-card border-2 border-brand rounded-xl md:rounded-2xl p-5 md:p-6 mb-5 box-glow" data-id="element-208">
        <div className="flex items-center justify-between mb-4" data-id="element-209">
          <div className="inline-flex items-center gap-1.5 bg-brand/15 text-brand text-[10px] md:text-xs font-bold uppercase tracking-widest px-2.5 py-1 rounded-full" data-id="element-210">
            <Flame className="w-3 h-3" data-id="element-211" />
            Plan Esencial
          </div>
        </div>

        <div className="flex items-baseline gap-2 mb-1" data-id="element-212">
          <p className={`font-display text-brand leading-none ${variant === 'compact' ? 'text-5xl md:text-6xl' : 'text-6xl md:text-7xl'}`} data-id="element-213">
            $14.990
          </p>
          <span className="text-xs md:text-sm text-gray-400 font-bold uppercase tracking-wider" data-id="element-214">
            ARS
          </span>
        </div>
        <p className="text-xs md:text-sm text-gray-400 mb-5" data-id="element-215">
          Pago único · Acceso de por vida
        </p>

        <ul className="space-y-2 mb-2" data-id="element-216">
          {features.map((feature, i) => <li key={i} className="flex items-start gap-2 text-sm md:text-base text-gray-200 leading-snug" data-id="element-217">
              <Check className="w-4 h-4 md:w-5 md:h-5 text-brand shrink-0 mt-0.5" strokeWidth={3} data-id="element-218" />
              <span data-id="element-219">{feature}</span>
            </li>)}
        </ul>
      </div>

      <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={handlePurchase} className="relative group overflow-hidden rounded-lg bg-brand w-full px-6 py-4 md:py-5 font-display text-xl md:text-2xl tracking-wider text-white shadow-[0_0_30px_rgba(234,88,12,0.5)] transition-all hover:bg-brand-light hover:shadow-[0_0_40px_rgba(234,88,12,0.7)]" data-id="element-220">
        <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-221" />
        <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-222">
          <Flame className="w-5 h-5 md:w-6 md:h-6 fill-current" data-id="element-223" />
          {ctaLabel}
        </span>
      </motion.button>

      <p className="text-center text-[11px] md:text-xs text-gray-500 mt-3 flex items-center justify-center gap-1.5" data-id="element-224">
        <Sparkles className="w-3 h-3 text-brand" data-id="element-225" />
        Acceso inmediato después de la compra · Pago 100% seguro
      </p>

      {showTrust && <div className="mt-6" data-id="element-226">
          <TrustBadges data-id="element-227" />
        </div>}
    </div>;
}